export const BADGE_INFO_MODAL_DATA = [
  {
    level: "New",
    description: "новый эксперт, свежий взгляд.",
  },
  {
    level: "Bronze",
    description: "набрал доверие и хорошие отзывы.",
  },
  {
    level: "Silver",
    description: "уверенный и надёжный.",
  },
  {
    level: "Gold",
    description: "один из любимцев клиентов.",
  },
  {
    level: "Platinum",
    description: "высокий уровень, сложные ситуации.",
  },
  {
    level: "Diamond",
    description: "лучшие из лучших, топ Лунаро.",
  },
  {
    level: "Exclusive",
    description: "премиум-эксперты.",
  },
];
